import { useQuery } from '@tanstack/react-query';
import {
  ConcessionPaymentProvidersResponse,
  getConcessionPaymentProviders,
} from 'commons/services';

const CONCESSION_PAYMENT_PROVIDERS_QUERY_KEY = [
  'concession-payment-providers',
] as const;

export const useGetConcessionPaymentProviders = () => {
  const { data, isLoading, error } =
    useQuery<ConcessionPaymentProvidersResponse>({
      queryKey: CONCESSION_PAYMENT_PROVIDERS_QUERY_KEY,
      queryFn: getConcessionPaymentProviders,
      staleTime: 30_000,
    });

  return { data, isLoading, error };
};
